
<script>
import FollowUp from '../../views/interessados/Followup'

export default {
  name: 'FormularioFollowUp',
  extends: FollowUp
}
</script>
